import { PREMIUM_URL, TARGET_STEP_PARAM, WIX_DASHBOARD_URL, WIX_LOGIN_URL } from 'config/consts';
import { redirectToUrl, assertString, buildUrlWithParams, getMobileProvider } from '@wix/gg-common-lib/utils';
import { useAppStore } from 'stores/state';
import { StepId } from 'config/flow';

const _forceStale = () => new Promise((resolve) => setTimeout(resolve, 30 * 1000));

const redirectToLogin = async (postLoginStepId: StepId) => {
  const redirectUrl = buildUrlWithParams(window.location.href, {
    [TARGET_STEP_PARAM]: postLoginStepId,
  });
  redirectToUrl(WIX_LOGIN_URL, {
    postSignUp: redirectUrl,
    postLogin: redirectUrl,
    forceRender: 'true',
  });
  await _forceStale();
};

const redirectToUpgradePlan = async () => {
  const { metaSiteId } = useAppStore.getState();
  assertString(metaSiteId);
  redirectToUrl(PREMIUM_URL, {
    siteGuid: metaSiteId,
    referralAdditionalInfo: 'add-domain-purchase-intent-dropshipping',
    petri_ovr: 'specs.premium.RemoveLightPlanForDropShipping:true',
  });
  await _forceStale();
};

const redirectToDashboard = async () => {
  const { metaSiteId } = useAppStore.getState();
  assertString(metaSiteId);
  const url = [WIX_DASHBOARD_URL, metaSiteId].join('/');
  redirectToUrl(url);
  await _forceStale();
};

const redirectToMobileApp = async () => {
  const mobileProvider = getMobileProvider();
  if (mobileProvider === 'apple') {
    redirectToUrl('https://apps.apple.com/app/id1545924344');
  } else if (mobileProvider === 'google') {
    redirectToUrl('https://play.google.com/store/apps/details?id=com.wix.admin');
  }
};

export const redirects = {
  redirectToUpgradePlan,
  redirectToDashboard,
  redirectToLogin,
  redirectToMobileApp,
};
